class Identity {
	constructor({ name, logo, favicon, alertConfigs }) {
		this.name = name;
		this.logo = logo;
		this.favicon = favicon;
		this.alertConfigs = alertConfigs;
	}
}

export default Identity;
